import React, { useContext } from 'react'
import { ThemeContext } from 'f-web-app'

export default function ForgotPasswordButtonView({ label = 'Forgot Password' }) {
  const { Components } = useContext(ThemeContext)
  return <Components.TextButtonView label={label} />
}
